<template>
  <el-card>
      <el-row>
          <el-form :model="form" v-bind="formProps.form" :rules="{}">
              <el-form-item :label="$t('orders.label.form.merchatNo')">
                  <el-input v-model.trim="form.merchantNo"></el-input>
              </el-form-item>
              <el-form-item :label="$t('merchantBalance.label.createTime')">
                  <el-date-picker type="datetime" size="small" v-model="form.createTime"
                      value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="handleSearch()">{{ $t("btns.search") }}</el-button>
                  <el-button v-if="tableData.rows > 0 && permission.indexOf('orderRecord:balance:export') != -1"
                      @click="getExportData()" size="mini" type="primary">{{ $t("btns.export") }}
                  </el-button>
              </el-form-item>

             <div style="margin-left:20px;">
                <el-form-item :label="$t('merchantBalance.label.todayTradeAmount')">
                    <span style="margin-right:10px;">{{ summary.todayTradeAmount | toThousands }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('merchantBalance.label.todayPayoutAmount')">
                    <span style="margin-right:10px;">{{ summary.todayPayoutAmount | toThousands }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('merchantBalance.label.todayBalanceAmount')">
                    <span style="margin-right:10px;"> {{ summary.todayBalanceAmount | toThousands }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('merchantBalance.label.yesterdayTradeAmount')">
                    <span>{{ summary.yesterdayTradeAmount | toThousands }}</span>
                  </el-form-item>
             </div>

          </el-form>
      </el-row>

      <el-row>
          <el-table v-loading="tableLoading" :data="tableData.list" :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ textAlign: 'center' }">
              <el-table-column type="index" label="#"></el-table-column>
              <el-table-column :label="$t('orders.label.form.merchatNo')" prop="merchantNo" />
              <el-table-column :label="$t('clientmanage.table.merchantName')" prop="merchantName" />
              <el-table-column :label="$t('merchantBalance.label.zalo')" prop="zaloBalance">
                <template slot-scope="{ row }">
                    {{ row.zaloBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.momo')" prop="momoBalance">
                <template slot-scope="{ row }">
                    {{ row.momoBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.vtp')" prop="viettelBalance">
                <template slot-scope="{ row }">
                    {{ row.viettelBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.vtpFix')" prop="viettelFixBalance">
                <template slot-scope="{ row }">
                    {{ row.viettelFixBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.bankOnline')" prop="bankOnlineBalance">
                <template slot-scope="{ row }">
                    {{ row.bankOnlineBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.transfer')" prop="bankTransferBalance">
                <template slot-scope="{ row }">
                    {{ row.bankTransferBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.bankQr')" prop="bankQrBalance">
                <template slot-scope="{ row }">
                    {{ row.bankQrBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.all')" prop="allBalance">
                <template slot-scope="{ row }">
                    {{ row.allBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.card')" prop="cardPcBalance">
                <template slot-scope="{ row }">
                    {{ row.cardPcBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.payout')" prop="payoutBalance">
                <template slot-scope="{ row }">
                    {{ row.payoutBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column label="QR Pro" prop="qrProBalance" >
                <template slot-scope="{ row }">
                    {{ row.qrProBalance | toThousands }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('merchantBalance.label.createTime')" prop="createTime" />
          </el-table>
      </el-row>

      <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />
  </el-card>
</template>

<script>
  import merchantApi from "@/api/merchant";
  import { debounce } from "lodash";
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
      name: "MerchantBalanceHis",
      data() {
          return {
              form: {
                  merchantNo: "",
                  createTime: ""
              },
              pagination: {
                  no: 1,
                  size: 100
              },
              tableData: {},
              tableLoading: true
          };
      },
      computed: {
          ...mapGetters(["permission"]),
        summary() {
          return this.tableData.summary || {};
        }
      },
      created() {
          this.init();
      },
      mounted() {
          this.getTableData();
      },
      methods: {
          init() {
              this.handleSearch = debounce(this._handleSearch, 300);
              let now = new Date();
              let y, m, d, h;
              y = now.getFullYear();
              m = now.getMonth() + 1 > 9 ? now.getMonth() + 1 : `0${now.getMonth() + 1}`;
              d = now.getDate() > 9 ? now.getDate() : `0${now.getDate()}`;
              h = now.getHours() - 1 > 9 ? now.getHours() - 1 : `0${now.getHours() - 1}`;
              let queryTime = `${y}-${m}-${d} ${h}:59:59`;
              this.form.createTime = moment(queryTime).format("YYYY-MM-DD HH:mm:ss");
              /* ----------------------------- element -props ----------------------------- */
              this.formProps = {
                  form: {
                      ref: "form",
                      "label-width": "auto",
                      inline: true,
                      size: "small"
                  }
              };
          },
          async getTableData() {
              const { data } = await merchantApi.getMerchantBalanceHis({
                  data: this.form,
                  params: this.pagination
              });
              if (data && data.code == 200) {
                  this.tableData = data.data;
              }
              this.tableLoading = false;
          },
          async getExportData() {
              const { data } = await merchantApi.exportMerchantBalanceHis({ data: this.form });
              if (data) {
                  const BLOB = data;
                  const fileReader = new FileReader();
                  fileReader.readAsDataURL(BLOB);
                  fileReader.onload = (event) => {
                      // 处理load事件。该事件在读取操作完成时触发
                      // 新建个下载的a标签，完成后移除。
                      let a = document.createElement("a");
                      a.download = `BALANCE-HIST${Number(new Date())}.xlsx`;
                      a.href = event.target.result;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                  };
              }
          },
          _handleSearch() {
              this.$refs.form.validate(async (valid) => valid && this.getTableData());
          }
      }
  };
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/balance-history/index.vue